import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`What we offer`}</h2>
    <ProjectCard title="" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  <h5>Let us help you with your daily chores</h5>
    </ProjectCard>
    <ProjectCard title="" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  <h5>Allow us to get you the stuff you want the way you want</h5>
    </ProjectCard>
    <ProjectCard bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">   
      <h5>Want to share your imagination with the world? We are here to enable you to
do just that.</h5>
    </ProjectCard>
    <ProjectCard title="" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
      <h5>Much more.....</h5>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      